export const inputBlackList = '$';
